import { v4 as uuidv4 } from 'uuid';

// Offset to convert windows file time based timestamp to JS Date based timestamp
export const winFileTimeToJSEpochDiffMSec = 11644473600000;

// Convert windows file time based timestamp to JS Date
export function winFileTimeToJSDate(winFileTimeMsec: number): Date {
    return new Date(winFileTimeMsec - winFileTimeToJSEpochDiffMSec);
}

// Convert windows file time (in msec) to Javascript time in msec
export function winFileTimeToJSTimeMsec(winFileTimeMsec: number): number {
    return winFileTimeMsec - winFileTimeToJSEpochDiffMSec;
}

function replaceErrors(key: any, value: any): any {
    if (value instanceof Error) {
        const error: any = {};

        Object.getOwnPropertyNames(value).forEach((keyProp: any) => {
            // eslint-disable-next-line security/detect-object-injection
            error[keyProp] = (value as any)[keyProp];
        });
        return error;
    }
    return value;
}

/** Removes the text after "Bearer ..." to not show auth codes in error messages */
function removeBearerIfAny(errorStr: string | null): string | null {
    if (errorStr == null) {
        return null;
    }
    const bearerStart = "\"Bearer ";
    const startIndex = errorStr.indexOf(bearerStart);
    if (startIndex < 0) { // if no bearer text
        return errorStr;
    }

    const endIndex = errorStr.indexOf("\"", startIndex + bearerStart.length);
    if (endIndex < 0) { // if no bearer text
        return errorStr;
    }

    const result = errorStr.substring(0, startIndex + bearerStart.length) + "AUTH_CODE" + errorStr.substring(endIndex);
    return result;
}

export function stringFromErrorOrAny(errorOrAnything: any): string {
    if (errorOrAnything && (typeof errorOrAnything === 'string')) {
        return removeBearerIfAny(errorOrAnything);
    }

    if (errorOrAnything?.message) { // if likely axios error
        return removeBearerIfAny(errorOrAnything.message);
    }

    if (errorOrAnything.text) { // if likely WebSocket error message from feedback.exe
        return removeBearerIfAny(errorOrAnything.text);
    }

    try {
        return removeBearerIfAny(JSON.stringify(errorOrAnything || {}, replaceErrors));
    }
    catch {
        return removeBearerIfAny((errorOrAnything || {}).toString());
    }
}

export function delay(timeoutMs: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, timeoutMs));
}

// Check whether text contains HTML. Used to detect markdown submitted via AHub as AHub stores it as HTML
export function isHtmlText(text: string): boolean {
    return text && /<[^<]{1,10}>/i.test(text);
}

export const generateTrackingId = (): string => `${uuidv4()}${(new Date()).getTime()}`

/** Converts email like "testmail@test.com" to "te***il@test.com" */
export function partiallyDisguiseEmail(email: string): string {
    if (email == null) {
        return null;
    }

    const indexOfAt: number = email.indexOf("@");
    if (indexOfAt <= 0) {
        return email;
    }

    const lessThan4CharsBeforeAt = indexOfAt < 4;
    if (lessThan4CharsBeforeAt) {
        return `***${email.substr(indexOfAt)}`;
    }

    return `${email.substr(0, 2)}***${email.substr(indexOfAt - 2)}`;
}

export function isNullOrEmpty(str: string | null | undefined): boolean {
    return str === null || str === undefined || (typeof str === 'string' && str.trim().length === 0);
}
